import { render, staticRenderFns } from "./desktopSalesCalendar.vue?vue&type=template&id=2e6f72b2"
import script from "./desktopSalesCalendar.vue?vue&type=script&lang=js"
export * from "./desktopSalesCalendar.vue?vue&type=script&lang=js"
import style0 from "./desktopSalesCalendar.vue?vue&type=style&index=0&id=2e6f72b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports